

export function calculateLevelAndExperience(totalExperience: number): { level: number, remainingExperience: number, experienceNeeded: number } {
    // 斐波那契數列的初始值
    let fib1 = 50;
    let fib2 = 50;
    let level = 1;
    let experienceNeeded = fib1;

    // 計算等級和剩餘經驗值
    while (totalExperience >= experienceNeeded) {
        totalExperience -= experienceNeeded;
        level++;
        // 更新斐波那契數列的值
        const nextFib = fib1 + fib2;
        fib1 = fib2;
        fib2 = nextFib;
        experienceNeeded = fib1;
    }
        // 使用 toFixed 方法限制小數點後的位數
        totalExperience = parseFloat(totalExperience.toFixed(3));
        experienceNeeded = parseFloat(experienceNeeded.toFixed(3));

    return { level, remainingExperience: totalExperience, experienceNeeded };
}

export function calculateDayOfUse(days_of_use: number): {remainingDays: number, nextMultiplier: number} {
    let nextMultiplier = 1.0
    let remainingDays =0
    if (days_of_use < 2){
        nextMultiplier = 1.01
        remainingDays = 2-days_of_use
    }
    else if (days_of_use < 3){
        nextMultiplier = 1.02
        remainingDays = 3-days_of_use
    }
    else if (days_of_use < 5){
        nextMultiplier = 1.03
        remainingDays = 5-days_of_use
    }
    else if (days_of_use < 7){
        nextMultiplier = 1.05
        remainingDays = 7-days_of_use
    }
    else if (days_of_use < 10){
        nextMultiplier = 1.07
        remainingDays = 10-days_of_use
    }
    else if (days_of_use < 14){
        nextMultiplier = 1.09
        remainingDays = 14-days_of_use
    }
    else if (days_of_use < 21){
        nextMultiplier = 1.12
        remainingDays = 21-days_of_use
    }
    else if (days_of_use < 28){
        nextMultiplier = 1.15
        remainingDays = 28-days_of_use
    }
    else if (days_of_use < 60){
        nextMultiplier = 1.2
        remainingDays = 60-days_of_use
    }
    else if (days_of_use < 100){
        nextMultiplier = 1.3
        remainingDays = 100-days_of_use
    }
    else if (days_of_use < 200){
        nextMultiplier = 1.5
        remainingDays = 200-days_of_use
    } 
    else if (days_of_use < 365){
        nextMultiplier = 2
        remainingDays = 365-days_of_use
    } else {
        nextMultiplier = 2
        remainingDays = 0
    }
    return {remainingDays, nextMultiplier}
}
